import { cx as Pe, cy as le, cz as Re, cw as Te } from "./OBTResizeContainer-B2It6dfD.js";
import { cA as Zc, cB as el, cC as tl, A as al, a as nl, b as sl, c as ol, d as rl, e as cl, f as ll, g as il, C as _l, h as dl, i as ml, j as pl, k as ul, l as El, m as bl, n as fl, o as yl, p as gl, q as hl, r as vl, s as kl, t as Nl, u as Al, v as $l, w as wl, x as xl, y as Xl, z as Cl, B as Sl, D as Bl, E as Fl, F as jl, G as Ll, H as Il, I as Dl, J as Ml, K as Pl, L as Rl, M as Tl, N as Ol, O as Gl, P as ql, Q as Wl, R as zl, S as Kl, T as Hl, U as Ul, V as Vl, W as Ql, X as Yl, Y as Jl, Z as Zl, _ as ei, $ as ti, a0 as ai, a1 as ni, a2 as si, a3 as oi, a4 as ri, a5 as ci, a6 as li, a7 as ii, a8 as _i, a9 as di, aa as mi, ab as pi, ac as ui, ad as Ei, ae as bi, af as fi, ag as yi, ah as gi, ai as hi, aj as vi, ak as ki, al as Ni, am as Ai, an as $i, ao as wi, ap as xi, aq as Xi, ar as Ci, as as Si, at as Bi, au as Fi, av as ji, aw as Li, ax as Ii, ay as Di, az as Mi, aA as Pi, aB as Ri, aC as Ti, aD as Oi, aE as Gi, aF as qi, aG as Wi, aH as zi, aI as Ki, aJ as Hi, aK as Ui, aL as Vi, aM as Qi, aN as Yi, aO as Ji, aP as Zi, aQ as e_, aR as t_, aS as a_, aT as n_, aU as s_, aV as o_, cD as r_, aW as c_, aX as l_, aY as i_, aZ as __, a_ as d_, a$ as m_, b0 as p_, b1 as u_, b2 as E_, b3 as b_, b4 as f_, b5 as y_, b6 as g_, b7 as h_, b8 as v_, b9 as k_, ba as N_, bb as A_, bc as $_, bd as w_, cE as x_, cF as X_, cG as C_, cH as S_, be as B_, bf as F_, bg as j_, bh as L_, bi as I_, bj as D_, bk as M_, bl as P_, bm as R_, bn as T_, bo as O_, bp as G_, bq as q_, br as W_, bs as z_, bt as K_, bu as H_, bv as U_, bw as V_, bx as Q_, by as Y_, bz as J_, bA as Z_, bB as ed, bC as td, bD as ad, bE as nd, bF as sd, bG as od, bH as rd, bI as cd, bJ as ld, bK as id, bL as _d, bM as dd, bN as md, bO as pd, bP as ud, bQ as Ed, bR as bd, bS as fd, bT as yd, bU as gd, bV as hd, bW as vd, bX as kd, bY as Nd, bZ as Ad, b_ as $d, b$ as wd, c0 as xd, cI as Xd, cJ as Cd, c1 as Sd, c2 as Bd, cK as Fd, cL as jd, c3 as Ld, c4 as Id, c5 as Dd, c6 as Md, c7 as Pd, cM as Rd, cN as Td, cO as Od, cP as Gd, c8 as qd, cQ as Wd, c9 as zd, ca as Kd, cb as Hd, cR as Ud, cS as Vd, cT as Qd, cU as Yd, cV as Jd, cW as Zd, cX as em, cY as tm, cZ as am, cc as nm, cd as sm, ce as om, cf as rm, cg as cm, ch as lm, ci as im, cj as _m, ck as dm, cl as mm, cm as pm, cn as um, co as Em, cp as bm, cq as fm, cr as ym, cs as gm, ct as hm, cu as vm, cv as km } from "./OBTResizeContainer-B2It6dfD.js";
import * as e from "react";
import { useState as A, useEffect as Z, useRef as J, useCallback as de, Fragment as Ke } from "react";
import { p as Oe, e as He, o as Ue, h as Ve, d as Qe } from "./format-CVedM0M8.js";
import { A as Am, a as $m, b as wm, c as xm, f as Xm, g as Cm, i as Sm, j as Bm, k as Fm, l as jm, m as Lm, n as Im, s as Dm, t as Mm } from "./format-CVedM0M8.js";
const pc = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, $e = "JPY";
let ye = null;
function Ge() {
  return ye || (ye = le(`${Re}/chat-api/api/basicinfo/common/companies`).then((t) => t.ok ? t.json() : []).catch(() => []).then((t) => (t.length || (ye = null), t))), ye;
}
function Ye(t, a) {
  var s, r, o;
  const n = (s = t.find((l) => l.comSq === a)) != null ? s : t[0];
  return n && (o = (r = n.dispCurCd) != null ? r : n.baseCurCd) != null ? o : null;
}
function uc() {
  return Ge().then((t) => {
    var n;
    const a = qe(t, (n = Pe()) == null ? void 0 : n.comSq);
    a && Oe(a);
  }, () => {
  });
}
function qe(t, a) {
  var s, r;
  const n = (s = t.find((o) => o.comSq === a)) != null ? s : t[0];
  return (r = n == null ? void 0 : n.baseCurCd) != null ? r : null;
}
function Je(t, a) {
  return { code: t, digits: Qe(t), fmt: (n) => Ve(n, t), unit: Ue(t, a), text: He(t, a) };
}
function Ze(t) {
  const [a, n] = A($e), [s, r] = A($e);
  return Z(() => {
    let o = !0;
    return Ge().then((l) => {
      var m;
      const _ = (m = Pe()) == null ? void 0 : m.comSq, c = Ye(l, _), i = qe(l, _);
      o && (c && n(c), i && (r(i), Oe(i)));
    }), () => {
      o = !1;
    };
  }, []), Je(a, { base: s, ...t });
}
function Ec({ className: t, hideBaseUnit: a = !0 }) {
  const { unit: n } = Ze({ hideBaseUnit: a });
  return n ? /* @__PURE__ */ e.createElement("span", { className: t, "data-currency-unit": !0 }, n) : null;
}
let ie = Re + "/chat-api/api/comments";
function bc(t) {
  t.base && (ie = t.base);
}
function et(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function fe(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function we(t, a, n, s, r) {
  const o = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(s) }), l = await le(`${ie}?${o}`, { cache: "no-store", signal: r });
  return fe(l);
}
async function tt(t, a, n, s) {
  const r = await le(ie, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: s })
  });
  return fe(r);
}
async function at(t, a) {
  const n = await le(`${ie}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return fe(n);
}
async function nt(t) {
  const a = await le(`${ie}/${t}`, { method: "DELETE" });
  return (await fe(a)).status;
}
async function st(t, a, n) {
  if (a.length === 0) return {};
  const s = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await le(`${ie}/counts?${s}`, { cache: "no-store", signal: n });
  return (await fe(r)).counts;
}
const xe = 50;
function Ne(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function ot(t, a) {
  if (Ne(a)) return [...t, a];
  const n = a.parentId;
  let s = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (s = r);
  return s < 0 ? [...t, a] : [...t.slice(0, s + 1), a, ...t.slice(s + 1)];
}
function me(t, a) {
  return a;
}
function rt(t, a) {
  const [n, s] = A([]), [r, o] = A(!0), [l, _] = A(!0), [c, i] = A(null), [m, d] = A(0), [p, b] = A(0), y = t + " " + a, E = J(y);
  E.current = y;
  const [h, $] = A(0), X = de(() => $((f) => f + 1), []);
  Z(() => {
    const f = new AbortController(), v = y;
    return s([]), b(0), d(0), i(null), o(!0), _(!0), we(t, a, 0, xe, f.signal).then((g) => {
      E.current === v && (s(g.items), d(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || i(me(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (o(!1), _(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(Ne).length < m, G = de(() => {
    if (r || !O) return;
    const f = p + 1, v = E.current;
    o(!0), we(t, a, f, xe).then((g) => {
      E.current === v && (s((S) => [...S, ...g.items]), d(g.total), b(f));
    }).catch((g) => {
      E.current === v && i(me(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && o(!1);
    });
  }, [r, O, p, t, a]), U = de(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const S = -Date.now(), B = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    s((L) => ot(L, B)), i(null);
    try {
      const L = await tt(t, a, g, v);
      return E.current !== D || (s((V) => V.map((k) => k.id === S ? L : k)), v === void 0 && d((V) => V + 1)), !0;
    } catch (L) {
      return E.current !== D || (s((V) => V.filter((k) => k.id !== S)), i(me(L, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = de(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const B = await at(f, g);
      return E.current !== S || s((D) => D.map((L) => L.id === f ? B : L)), !0;
    } catch (B) {
      return E.current === S && i(me(B, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), _e = de(async (f) => {
    const v = E.current;
    try {
      const g = await nt(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (s((S) => S.map((B) => B.id === f ? { ...B, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : B)), !0) : (s((S) => {
        const B = S.find((k) => k.id === f), D = S.filter((k) => k.id !== f);
        if (!B) return D;
        if (Ne(B))
          return d((k) => Math.max(0, k - 1)), D;
        const L = B.parentId, V = D.find((k) => k.id === L);
        return V && V.deleted && !D.some((k) => k.parentId === L) ? (d((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== L)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(me(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: G,
    reload: X,
    add: U,
    edit: C,
    remove: _e
  };
}
const ct = "_thread_1layy_9", lt = "_head_1layy_28", it = "_headTitle_1layy_37", _t = "_headCount_1layy_43", dt = "_list_1layy_54", mt = "_row_1layy_61", pt = "_isReply_1layy_73", ut = "_pending_1layy_80", Et = "_avatar_1layy_84", bt = "_avatarGhost_1layy_98", ft = "_body_1layy_103", yt = "_meta_1layy_108", gt = "_author_1layy_116", ht = "_dept_1layy_122", vt = "_time_1layy_130", kt = "_text_1layy_135", Nt = "_textDeleted_1layy_143", At = "_acts_1layy_148", $t = "_act_1layy_148", wt = "_actDanger_1layy_169", xt = "_empty_1layy_175", Xt = "_error_1layy_182", Ct = "_skeleton_1layy_196", St = "_more_1layy_219", Bt = "_foot_1layy_245", Ft = "_composer_1layy_252", jt = "_composerInput_1layy_261", Lt = "_composerActions_1layy_284", It = "_btn_1layy_291", Dt = "_btnPrimary_1layy_301", Mt = "_btnGhost_1layy_310", u = {
  thread: ct,
  head: lt,
  headTitle: it,
  headCount: _t,
  list: dt,
  row: mt,
  isReply: pt,
  pending: ut,
  avatar: Et,
  avatarGhost: bt,
  body: ft,
  meta: yt,
  author: gt,
  dept: ht,
  time: vt,
  text: kt,
  textDeleted: Nt,
  acts: At,
  act: $t,
  actDanger: wt,
  empty: xt,
  error: Xt,
  skeleton: Ct,
  more: St,
  foot: Bt,
  composer: Ft,
  composerInput: jt,
  composerActions: Lt,
  btn: It,
  btnPrimary: Dt,
  btnGhost: Mt
}, Xe = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Pt(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return Xe[a % Xe.length];
}
function Rt(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Ce = 6e4, Se = 36e5, Be = 864e5, Tt = 6048e5;
function Ot(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Ce) return "방금";
  if (n < Se) return `${Math.floor(n / Ce)}분 전`;
  if (n < Be) return `${Math.floor(n / Se)}시간 전`;
  if (n < Tt) return `${Math.floor(n / Be)}일 전`;
  const s = new Date(a), r = (o) => o < 10 ? `0${o}` : String(o);
  return `${s.getFullYear()}.${r(s.getMonth() + 1)}.${r(s.getDate())}`;
}
function Ae({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: s,
  onSubmit: r,
  onCancel: o
}) {
  const [l, _] = A(s != null ? s : ""), [c, i] = A(!1), m = J(null);
  Z(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const d = async () => {
    const p = l.trim();
    if (!p || c) return;
    i(!0);
    const b = await r(p);
    i(!1), b && _("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: u.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: u.composerInput,
      rows: s === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (p) => _(p.target.value),
      onKeyDown: (p) => {
        const b = p.nativeEvent.isComposing;
        p.key === "Enter" && !p.shiftKey && !b && (p.preventDefault(), d()), p.key === "Escape" && o && (p.nativeEvent.stopPropagation(), o());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: u.composerActions }, o && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${u.btn} ${u.btnGhost}`,
      onClick: o,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${u.btn} ${u.btnPrimary}`,
      onClick: () => void d(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function Gt({
  item: t,
  replying: a,
  editing: n,
  onReply: s,
  onEdit: r,
  onSubmitReply: o,
  onSubmitEdit: l,
  onDelete: _,
  onCancel: c
}) {
  var p, b;
  const i = et(t), m = i ? ` ${u.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${u.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${u.avatar} ${u.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: u.body }, /* @__PURE__ */ e.createElement("div", { className: `${u.text} ${u.textDeleted}` }, "삭제된 댓글입니다")));
  const d = (p = t.authorName) != null ? p : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${u.row}${m}${t.pending ? ` ${u.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: u.avatar, style: { background: Pt(d) } }, Rt(d)), /* @__PURE__ */ e.createElement("div", { className: u.body }, /* @__PURE__ */ e.createElement("div", { className: u.meta }, /* @__PURE__ */ e.createElement("span", { className: u.author }, d), t.dept && /* @__PURE__ */ e.createElement("span", { className: u.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: u.time }, Ot(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: u.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Ae,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: u.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: u.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: u.act, onClick: s }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: u.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${u.act} ${u.actDanger}`,
      onClick: _
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Ae,
    {
      placeholder: `${d} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: o,
      onCancel: c
    }
  )));
}
function fc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: s,
  showHeader: r = !0,
  className: o,
  style: l
}) {
  const { items: _, initialLoading: c, loading: i, error: m, count: d, hasMore: p, loadMore: b, reload: y, add: E, edit: h, remove: $ } = rt(t, a), [X, P] = A(null), [O, G] = A(null);
  Z(() => {
    P(null), G(null);
  }, [t, a]);
  const U = J(n);
  return U.current = n, Z(() => {
    !c && U.current && U.current(d);
  }, [d, c]), /* @__PURE__ */ e.createElement("div", { className: o ? `${u.thread} ${o}` : u.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: u.head }, /* @__PURE__ */ e.createElement("span", { className: u.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: u.headCount }, d)), /* @__PURE__ */ e.createElement("div", { className: u.list }, c && /* @__PURE__ */ e.createElement("div", { className: u.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: u.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${u.btn} ${u.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && _.length === 0 && /* @__PURE__ */ e.createElement("div", { className: u.empty }, "첫 댓글을 남겨 보세요."), _.map((C) => /* @__PURE__ */ e.createElement(
    Gt,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        G(null), P(C.id);
      },
      onEdit: () => {
        P(null), G(C.id);
      },
      onCancel: () => {
        P(null), G(null);
      },
      onSubmitReply: async (_e) => {
        const f = await E(_e, C.id);
        return f && P(null), f;
      },
      onSubmitEdit: async (_e) => {
        const f = await h(C.id, _e);
        return f && G(null), f;
      },
      onDelete: () => {
        $(C.id);
      }
    }
  )), p && /* @__PURE__ */ e.createElement("button", { type: "button", className: u.more, onClick: b, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: u.foot }, /* @__PURE__ */ e.createElement(
    Ae,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: s,
      onSubmit: (C) => E(C)
    }
  )));
}
function yc(t, a) {
  const [n, s] = A({}), [r, o] = A(!1), [l, _] = A(0), c = a.join(",");
  return Z(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      s({});
      return;
    }
    const m = new AbortController();
    return o(!0), st(t, i, m.signal).then((d) => {
      m.signal.aborted || s(d);
    }).catch(() => {
      m.signal.aborted || s({});
    }).finally(() => {
      m.signal.aborted || o(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => _((i) => i + 1)
  };
}
const qt = "_card_epi3f_1", Wt = "_header_epi3f_8", zt = "_headerNoDivider_epi3f_13", Kt = "_body_epi3f_17", Ht = "_paddingSm_epi3f_22", Ut = "_paddingMd_epi3f_26", Vt = "_paddingLg_epi3f_30", q = {
  card: qt,
  header: Wt,
  headerNoDivider: zt,
  body: Kt,
  paddingSm: Ht,
  paddingMd: Ut,
  paddingLg: Vt
};
function gc({
  children: t,
  header: a,
  padding: n = "md",
  radius: s,
  headerDivider: r = !0,
  headerBackground: o,
  headerPadding: l,
  headerBorderColor: _,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? q.paddingSm : n === "lg" ? q.paddingLg : q.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, d = c ? `${q.card} ${c}` : q.card, p = r ? q.header : `${q.header} ${q.headerNoDivider}`, b = {
    ...o !== void 0 ? { background: o } : {},
    ...l !== void 0 ? { padding: l } : {},
    ..._ !== void 0 ? { borderBottomColor: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: d, style: s !== void 0 ? { borderRadius: s } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: p, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${q.body} ${i}`, style: m }, t));
}
const Qt = "_horizontal_mkht7_1", Yt = "_vertical_mkht7_8", Fe = {
  horizontal: Qt,
  vertical: Yt
};
function hc({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const s = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: s ? Fe.vertical : Fe.horizontal,
      style: {
        ...s ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const Jt = "_root_nvy8t_1", Zt = "_icon_nvy8t_7", ea = "_iconBadge_nvy8t_15", ta = "_titleGroup_nvy8t_25", aa = "_title_nvy8t_25", na = "_subtitle_nvy8t_41", sa = "_trailing_nvy8t_49", oa = "_closeButton_nvy8t_58", Q = {
  root: Jt,
  icon: Zt,
  iconBadge: ea,
  titleGroup: ta,
  title: aa,
  subtitle: na,
  trailing: sa,
  closeButton: oa
};
function vc({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: s = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: o,
  title: l,
  titleWeight: _,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: d,
  trailing: p,
  onClose: b
}) {
  const y = {
    ..._ !== void 0 ? { fontWeight: _ } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ...d !== void 0 ? { fontSize: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${s}1A`, color: s },
        ...o !== void 0 ? { width: o, height: o } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), p && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, p), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const ra = "_badge_19977_1", ca = {
  badge: ra
};
function kc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const s = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ca.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: s, height: s, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const la = "_wrapper_ccmq2_1", ia = "_image_ccmq2_8", _a = "_fallback_ccmq2_16", da = "_statusDot_ccmq2_29", ge = {
  wrapper: la,
  image: ia,
  fallback: _a,
  statusDot: da
}, ma = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function pa(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const ve = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function ua(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return ve[5];
  let n = 0;
  for (let s = 0; s < a.length; s += 1)
    n = n * 31 + a.charCodeAt(s) | 0;
  return ve[Math.abs(n) % ve.length];
}
function We({
  src: t,
  fallbackText: a,
  alt: n,
  size: s = 32,
  statusDot: r,
  color: o,
  ring: l = !1,
  ringColor: _ = "#fff"
}) {
  var d;
  const [c, i] = A(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ge.wrapper,
      style: {
        width: s,
        height: s,
        ...l ? { boxShadow: `0 0 0 2px ${_}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ge.image,
        src: t,
        alt: (d = n != null ? n : a) != null ? d : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ge.fallback,
        style: {
          backgroundColor: o != null ? o : ua(a),
          fontSize: Math.max(10, s * 0.45)
        }
      },
      pa(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ge.statusDot,
        style: {
          backgroundColor: ma[r],
          width: Math.max(8, s * 0.28),
          height: Math.max(8, s * 0.28)
        }
      }
    )
  );
}
const Ea = "_stack_y8phg_1", ba = "_item_y8phg_6", fa = "_overflow_y8phg_18", he = {
  stack: Ea,
  item: ba,
  overflow: fa
};
function Nc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const s = t.slice(0, a), r = t.length - s.length;
  return /* @__PURE__ */ e.createElement("span", { className: he.stack }, s.map((o, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: he.item, style: { zIndex: s.length - l } }, /* @__PURE__ */ e.createElement(We, { src: o.src, alt: o.alt, fallbackText: o.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: he.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: he.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const ya = "_badge_1mjda_1", ga = "_pill_1mjda_15", ha = "_dot_1mjda_19", va = "_dotPulse_1mjda_26", ka = "_outline_1mjda_40", Na = "_soft_1mjda_46", pe = {
  badge: ya,
  pill: ga,
  dot: ha,
  dotPulse: va,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: ka,
  soft: Na
};
function Ac({
  label: t,
  variant: a = "default",
  color: n,
  background: s,
  textColor: r,
  shape: o = "rounded",
  dot: l = !1,
  dotColor: _,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const d = {};
  n && (a === "default" ? (d.backgroundColor = n, d.color = "#fff") : a === "outline" ? (d.borderColor = n, d.color = n) : (d.backgroundColor = `${n}1A`, d.color = n)), s !== void 0 && (d.backgroundColor = s), r !== void 0 && (d.color = r), i && (d.borderColor = m);
  const p = [
    pe.badge,
    pe[a],
    o === "pill" ? pe.pill : ""
  ].filter(Boolean).join(" "), b = [pe.dot, c ? pe.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: p, style: d }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: _ != null ? _ : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Aa = "_row_1k2ap_1", $a = "_reply_1k2ap_7", wa = "_avatar_1k2ap_12", xa = "_avatarImage_1k2ap_25", Xa = "_avatarFallback_1k2ap_32", Ca = "_body_1k2ap_44", Sa = "_headerLine_1k2ap_49", Ba = "_author_1k2ap_56", Fa = "_meta_1k2ap_62", ja = "_text_1k2ap_67", La = "_actionsRow_1k2ap_74", Ia = "_actionBtn_1k2ap_81", F = {
  row: Aa,
  reply: $a,
  avatar: wa,
  avatarImage: xa,
  avatarFallback: Xa,
  body: Ca,
  headerLine: Sa,
  author: Ba,
  meta: Fa,
  text: ja,
  actionsRow: La,
  actionBtn: Ia
};
function Da(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function $c({
  avatarSrc: t,
  author: a,
  meta: n,
  text: s,
  likeCount: r,
  replyCount: o,
  isReply: l = !1,
  onLikeClick: _,
  onReplyClick: c
}) {
  const [i, m] = A(!1), d = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${F.row} ${l ? F.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: F.avatar }, d ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: F.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: F.avatarFallback }, Da(a))), /* @__PURE__ */ e.createElement("div", { className: F.body }, /* @__PURE__ */ e.createElement("div", { className: F.headerLine }, /* @__PURE__ */ e.createElement("span", { className: F.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: F.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: F.text }, s), /* @__PURE__ */ e.createElement("div", { className: F.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: _ }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof o == "number" && /* @__PURE__ */ e.createElement("span", null, o)))));
}
const Ma = "_wrapper_79n51_1", Pa = {
  wrapper: Ma
}, Ra = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, Ta = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function Oa({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: s, color: r, bg: o } = (l = Ra[n]) != null ? l : Ta;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Pa.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: o,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    s
  );
}
const Ga = "_chip_1jhj8_1", qa = "_clickable_1jhj8_12", Wa = "_icon_1jhj8_21", za = "_info_1jhj8_26", Ka = "_name_1jhj8_33", Ha = "_size_1jhj8_42", Ua = "_chipError_1jhj8_48", Va = "_chipDone_1jhj8_53", Qa = "_status_1jhj8_57", Ya = "_statusError_1jhj8_66", Ja = "_statusDone_1jhj8_67", Za = "_statusIcon_1jhj8_69", en = "_statusLabel_1jhj8_71", tn = "_progressTrack_1jhj8_78", an = "_progressFill_1jhj8_88", nn = "_actionBtn_1jhj8_96", N = {
  chip: Ga,
  clickable: qa,
  icon: Wa,
  info: za,
  name: Ka,
  size: Ha,
  chipError: Ua,
  chipDone: Va,
  status: Qa,
  statusError: Ya,
  statusDone: Ja,
  statusIcon: Za,
  statusLabel: en,
  progressTrack: tn,
  progressFill: an,
  actionBtn: nn
};
function wc({
  name: t,
  ext: a,
  size: n,
  onRemove: s,
  downloadable: r = !1,
  onClick: o,
  status: l,
  statusText: _,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${o ? N.clickable : ""} ${i}`,
      onClick: o,
      title: l === "error" ? _ : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(Oa, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), _ ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, _)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : s ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), s();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const sn = "_list_1yxwc_1", on = "_row_1yxwc_6", rn = "_inline_1yxwc_15", cn = "_label_1yxwc_22", ln = "_value_1yxwc_29", _n = "_stacked_1yxwc_35", dn = "_bold_1yxwc_51", ne = {
  list: sn,
  row: on,
  inline: rn,
  label: cn,
  value: ln,
  stacked: _n,
  bold: dn
};
function xc({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, s) => /* @__PURE__ */ e.createElement("div", { key: s, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const mn = "_container_2r163_1", pn = "_row_2r163_5", un = "_clickable_2r163_12", En = "_leading_2r163_20", bn = "_main_2r163_26", fn = "_titleLine_2r163_34", yn = "_title_2r163_34", gn = "_tags_2r163_50", hn = "_meta_2r163_57", vn = "_actions_2r163_62", kn = "_expandable_2r163_69", M = {
  container: mn,
  row: pn,
  clickable: un,
  leading: En,
  main: bn,
  titleLine: fn,
  title: yn,
  tags: gn,
  meta: hn,
  actions: vn,
  expandable: kn
};
function Xc({
  leading: t,
  title: a,
  meta: n,
  tags: s,
  actions: r,
  expandableContent: o,
  expanded: l = !1,
  onClick: _
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${_ ? M.clickable : ""}`, onClick: _ }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), s && /* @__PURE__ */ e.createElement("span", { className: M.tags }, s)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && o && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, o));
}
const Nn = "_row_xzgny_1", An = "_info_xzgny_8", $n = "_name_xzgny_16", wn = "_subtitle_xzgny_25", xn = "_status_xzgny_33", ue = {
  row: Nn,
  info: An,
  name: $n,
  subtitle: wn,
  status: xn
};
function Cc({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: s,
  statusColor: r = "#64748B",
  statusBg: o = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: ue.row }, /* @__PURE__ */ e.createElement(We, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: ue.info }, /* @__PURE__ */ e.createElement("span", { className: ue.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: ue.subtitle }, n)), s && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ue.status,
      style: { color: r, backgroundColor: o }
    },
    s
  ));
}
const Xn = "_row_qoxwr_1", Cn = "_clickable_qoxwr_9", Sn = "_rank_qoxwr_17", Bn = "_title_qoxwr_25", Fn = "_trailing_qoxwr_36", Ee = {
  row: Xn,
  clickable: Cn,
  rank: Sn,
  title: Bn,
  trailing: Fn
}, jn = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function Sc({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: s,
  onClick: r
}) {
  var l;
  const o = (l = a != null ? a : jn[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Ee.row} ${r ? Ee.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: Ee.rank, style: { color: o } }, t), /* @__PURE__ */ e.createElement("span", { className: Ee.title }, n), s && /* @__PURE__ */ e.createElement("span", { className: Ee.trailing }, s));
}
const Ln = "_badge_1qibj_1", In = "_sm_1qibj_11", Dn = "_md_1qibj_16", Mn = "_overdue_1qibj_21", Pn = "_warning_1qibj_26", Rn = "_progress_1qibj_31", Tn = "_success_1qibj_36", On = "_info_1qibj_41", Gn = "_neutral_1qibj_46", ke = {
  badge: Ln,
  sm: In,
  md: Dn,
  overdue: Mn,
  warning: Pn,
  progress: Rn,
  success: Tn,
  info: On,
  neutral: Gn
};
function Bc({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: s,
  textColor: r
}) {
  const o = {};
  return s !== void 0 && (o.backgroundColor = s), r !== void 0 && (o.color = r), /* @__PURE__ */ e.createElement("span", { className: `${ke.badge} ${ke[a]} ${ke[n]}`, style: o }, t);
}
const qn = "_wrapper_14p14_1", Wn = "_avatar_14p14_11", zn = "_body_14p14_21", Kn = "_message_14p14_26", Hn = "_dots_14p14_32", Un = "_dot_14p14_32", Vn = "_action_14p14_70", Qn = "_actionIcon_14p14_89", Yn = "_gradientWrapper_14p14_95", Jn = "_bareIcon_14p14_100", Zn = "_ctaButton_14p14_109", w = {
  wrapper: qn,
  avatar: Wn,
  body: zn,
  message: Kn,
  dots: Hn,
  dot: Un,
  action: Vn,
  actionIcon: Qn,
  gradientWrapper: Yn,
  bareIcon: Jn,
  ctaButton: Zn
};
function je() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Le() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Fc({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: s,
  onAction: r,
  phase: o = "complete",
  variant: l = "card",
  gradientColors: _ = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [w.wrapper, c ? w.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${_[0]}, ${_[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: w.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(je, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: w.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(je, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: w.body }, o === "loading" ? /* @__PURE__ */ e.createElement("span", { className: w.dots }, /* @__PURE__ */ e.createElement("span", { className: w.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: w.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: w.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: w.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: w.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: w.actionIcon }, s === void 0 ? /* @__PURE__ */ e.createElement(Le, null) : s)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: w.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: w.actionIcon }, s === void 0 ? /* @__PURE__ */ e.createElement(Le, null) : s)
    ))
  );
}
const es = "_wrapper_68zkp_1", ts = "_bordered_68zkp_13", as = "_compact_68zkp_17", ns = "_icon_68zkp_23", ss = "_title_68zkp_31", os = "_description_68zkp_38", rs = "_action_68zkp_46", ee = {
  wrapper: es,
  bordered: ts,
  compact: as,
  icon: ns,
  title: ss,
  description: os,
  action: rs
};
function cs() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function jc({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: s,
  titleSize: r,
  titleWeight: o,
  description: l,
  actionLabel: _,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const d = {
    ...s !== void 0 ? { color: s } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...o !== void 0 ? { fontWeight: o } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ee.wrapper, i && !m ? ee.bordered : "", m ? ee.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: ee.icon }, t != null ? t : /* @__PURE__ */ e.createElement(cs, null)),
    /* @__PURE__ */ e.createElement("p", { className: ee.title, style: d }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: ee.description }, l),
    _ && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: ee.action, onClick: c }, _)
  );
}
const ls = "_wrapper_oide4_1", is = "_toggle_oide4_7", _s = "_toggleOpen_oide4_29", ds = "_panel_oide4_34", ms = "_text_oide4_41", be = {
  wrapper: ls,
  toggle: is,
  toggleOpen: _s,
  panel: ds,
  text: ms
};
function Lc({
  label: t,
  summaryText: a,
  open: n,
  onToggle: s
}) {
  return /* @__PURE__ */ e.createElement("div", { className: be.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [be.toggle, n ? be.toggleOpen : ""].join(" "),
      onClick: s,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: be.panel }, /* @__PURE__ */ e.createElement("p", { className: be.text }, a)));
}
const ps = "_wrapper_96dw1_1", us = "_labelRow_96dw1_8", Es = "_label_96dw1_8", bs = "_value_96dw1_21", fs = "_track_96dw1_27", ys = "_xs_96dw1_35", gs = "_sm_96dw1_39", hs = "_md_96dw1_43", vs = "_square_96dw1_47", ks = "_fill_96dw1_51", W = {
  wrapper: ps,
  labelRow: us,
  label: Es,
  value: bs,
  track: fs,
  xs: ys,
  sm: gs,
  md: hs,
  square: vs,
  fill: ks
};
function Ic({
  value: t,
  max: a = 100,
  label: n,
  color: s = "#3B82F6",
  gradient: r,
  size: o = "md",
  rounded: l = !0,
  height: _,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), d = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: s }, p = {
    ..._ !== void 0 ? { height: _ } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: W.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: W.labelRow }, /* @__PURE__ */ e.createElement("span", { className: W.label }, n), /* @__PURE__ */ e.createElement("span", { className: W.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [W.track, W[o], l ? "" : W.square].join(" "), style: p }, /* @__PURE__ */ e.createElement("div", { className: [W.fill, l ? "" : W.square].join(" "), style: d })));
}
const Ns = "_list_aixh6_1", As = "_vertical_aixh6_8", $s = "_horizontal_aixh6_13", ws = "_item_aixh6_18", xs = "_iconWrap_aixh6_41", Xs = "_iconSvg_aixh6_51", Cs = "_spin_aixh6_56", Ss = "_label_aixh6_70", Bs = "_item_active_aixh6_82", Fs = "_item_done_aixh6_87", js = "_connector_aixh6_91", Ls = "_cardList_aixh6_114", Is = "_cardItem_aixh6_122", Ds = "_card_pending_aixh6_133", Ms = "_card_active_aixh6_142", Ps = "_card_done_aixh6_152", x = {
  list: Ns,
  vertical: As,
  horizontal: $s,
  item: ws,
  iconWrap: xs,
  iconSvg: Xs,
  spin: Cs,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Ss,
  item_active: Bs,
  item_done: Fs,
  connector: js,
  cardList: Ls,
  cardItem: Is,
  card_pending: Ds,
  card_active: Ms,
  card_done: Ps
};
function Rs({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function Dc({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const s = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], s ? x.cardList : ""].join(" ") }, t.map((r, o) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${o}`,
      className: [
        x.item,
        s ? x.cardItem : "",
        x[`item_${r.status}`],
        s ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(Rs, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !s && o < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const Ts = "_wrapper_1ohmw_1", Os = "_icon_1ohmw_7", Gs = "_dots_1ohmw_14", qs = "_dot_1ohmw_14", Ws = "_sm_1ohmw_27", zs = "_md_1ohmw_32", te = {
  wrapper: Ts,
  icon: Os,
  dots: Gs,
  dot: qs,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: Ws,
  md: zs
};
function Mc({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: te.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: te.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [te.dots, te[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot })));
}
const Ks = "_container_85404_1", Hs = "_table_85404_9", Us = "_row_85404_31", Vs = "_striped_85404_35", Qs = "_clickable_85404_43", Ys = "_alignLeft_85404_47", Js = "_alignCenter_85404_51", Zs = "_alignRight_85404_55", eo = "_emptyCell_85404_59", z = {
  container: Ks,
  table: Hs,
  row: Us,
  striped: Vs,
  clickable: Qs,
  alignLeft: Ys,
  alignCenter: Js,
  alignRight: Zs,
  emptyCell: eo
};
function Pc({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: s,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const o = (l) => l === "center" ? z.alignCenter : l === "right" ? z.alignRight : z.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: z.container }, /* @__PURE__ */ e.createElement("table", { className: z.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: o(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: z.emptyCell, colSpan: t.length }, r)) : a.map((l, _) => {
    const c = [
      z.row,
      n && _ % 2 === 1 ? z.striped : "",
      s ? z.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: _,
        className: c,
        onClick: s ? () => s(l, _) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: o(i.align) }, l[i.key]))
    );
  }))));
}
const to = "_grid_plbcd_1", ao = "_cell_plbcd_6", no = "_primaryCell_plbcd_16", so = "_label_plbcd_21", oo = "_value_plbcd_26", ro = "_note_plbcd_32", se = {
  grid: to,
  cell: ao,
  primaryCell: no,
  label: so,
  value: oo,
  note: ro
};
function Rc({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: s,
  cellBorderColor: r,
  labelColor: o,
  valueColor: l,
  primaryBackground: _,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: se.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((d, p) => {
      const b = n && p === 0, y = [se.cell, b ? se.primaryCell : ""].filter(Boolean).join(" "), E = {};
      s !== void 0 && (E.background = s), r !== void 0 && (E.borderColor = r), b && _ !== void 0 && (E.background = _, E.borderColor = "transparent");
      const h = {};
      o !== void 0 && (h.color = o), b && c !== void 0 && (h.color = c);
      const $ = {};
      l !== void 0 && ($.color = l), b && i !== void 0 && ($.color = i);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${d.label}-${p}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: se.label, style: h }, d.label), /* @__PURE__ */ e.createElement("span", { className: se.value, style: $ }, d.value), d.note && /* @__PURE__ */ e.createElement("span", { className: se.note, style: X }, d.note));
    })
  );
}
const co = "_button_16ajt_1", lo = "_disabledSolid_16ajt_19", io = "_icon_16ajt_26", _o = "_label_16ajt_32", mo = "_fullWidth_16ajt_37", po = "_sm_16ajt_41", uo = "_md_16ajt_47", Eo = "_lg_16ajt_53", bo = "_primary_16ajt_59", fo = "_secondary_16ajt_70", yo = "_outline_16ajt_81", go = "_ghost_16ajt_93", ho = "_active_16ajt_104", vo = "_colorOverride_16ajt_116", ko = "_gradient_16ajt_126", No = "_dashed_16ajt_135", Ao = "_pill_16ajt_139", I = {
  button: co,
  disabledSolid: lo,
  icon: io,
  label: _o,
  fullWidth: mo,
  sm: po,
  md: uo,
  lg: Eo,
  primary: bo,
  secondary: fo,
  outline: yo,
  ghost: go,
  active: ho,
  colorOverride: vo,
  gradient: ko,
  dashed: No,
  pill: Ao
};
function Tc({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: s = "leading",
  disabled: r = !1,
  disabledVariant: o = "dim",
  onClick: l,
  children: _,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: d,
  background: p,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: $ = "solid",
  shape: X = "rounded"
}) {
  const P = d !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    I.button,
    I[t],
    I[a],
    c ? I.fullWidth : "",
    r && o === "solid" ? I.disabledSolid : "",
    m ? I.active : "",
    P ? I.colorOverride : "",
    h || p ? I.gradient : "",
    $ === "dashed" ? I.dashed : "",
    X === "pill" ? I.pill : ""
  ].filter(Boolean).join(" "), G = {
    ...d !== void 0 ? { "--ax-btn-color": d } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...p !== void 0 ? { background: p } : {}
  }, U = n && /* @__PURE__ */ e.createElement("span", { className: I.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: G,
      disabled: r,
      onClick: l
    },
    s === "leading" && U,
    /* @__PURE__ */ e.createElement("span", { className: I.label }, _),
    s === "trailing" && U
  );
}
const $o = "_iconButton_1oiog_1", wo = "_sm_1oiog_18", xo = "_md_1oiog_23", Xo = "_lg_1oiog_28", Co = "_plain_1oiog_33", So = "_outline_1oiog_42", Bo = "_circle_1oiog_53", Fo = "_bordered_1oiog_62", jo = "_tint_1oiog_73", Lo = "_active_1oiog_81", Io = "_hoverBgOverride_1oiog_92", Do = "_gradient_1oiog_96", Y = {
  iconButton: $o,
  sm: wo,
  md: xo,
  lg: Xo,
  plain: Co,
  outline: So,
  circle: Bo,
  bordered: Fo,
  tint: jo,
  active: Lo,
  hoverBgOverride: Io,
  gradient: Do
};
function Oc({
  icon: t,
  title: a,
  active: n = !1,
  size: s = "md",
  variant: r = "plain",
  onClick: o,
  onMouseDown: l,
  disabled: _ = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: d = "#e2e8f0",
  borderHoverColor: p = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: $
}) {
  const X = typeof s == "number", P = [
    Y.iconButton,
    X ? "" : Y[s],
    Y[r],
    n ? Y.active : "",
    m ? Y.bordered : "",
    b ? Y.tint : "",
    h !== void 0 ? Y.hoverBgOverride : "",
    $ ? Y.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: s, height: s } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": d, "--ax-icon-border-hover": p } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...$ ? { background: `linear-gradient(135deg, ${$[0]}, ${$[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: P,
      style: O,
      onClick: o,
      onMouseDown: l,
      disabled: _,
      title: a,
      "aria-label": a
    },
    t
  );
}
const Mo = "_control_8lntr_1", Po = "_option_8lntr_13", Ro = "_active_8lntr_31", To = "_sm_8lntr_40", Oo = "_md_8lntr_46", Go = "_dot_8lntr_52", qo = "_count_8lntr_59", Wo = "_outline_8lntr_73", zo = "_outlineOption_8lntr_78", K = {
  control: Mo,
  option: Po,
  active: Ro,
  sm: To,
  md: Oo,
  dot: Go,
  count: qo,
  outline: Wo,
  outlineOption: zo
};
function Gc({
  options: t,
  value: a,
  onChange: n,
  size: s = "md",
  variant: r = "filled",
  activeBackground: o,
  activeColor: l,
  activeBorderColor: _
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[s], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...o !== void 0 ? { background: o } : {},
        ...l !== void 0 ? { color: l } : {},
        ..._ !== void 0 ? { borderColor: _ } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const Ko = "_chip_8jgxm_1", Ho = "_clickable_8jgxm_14", Uo = "_suggested_8jgxm_23", Vo = "_readonly_8jgxm_33", Qo = "_plusIcon_8jgxm_39", Yo = "_label_8jgxm_45", Jo = "_removeButton_8jgxm_50", oe = {
  chip: Ko,
  clickable: Ho,
  default: "_default_8jgxm_18",
  suggested: Uo,
  readonly: Vo,
  plusIcon: Qo,
  label: Yo,
  removeButton: Jo
};
function qc({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: s,
  background: r,
  textColor: o,
  borderColor: l
}) {
  const _ = [oe.chip, oe[a], s ? oe.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || o !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...o !== void 0 ? { color: o } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, d = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: oe.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: oe.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: oe.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (p) => {
        p.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return s ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: _,
      style: i,
      onClick: s,
      onKeyDown: (p) => {
        (p.key === "Enter" || p.key === " ") && (p.preventDefault(), s());
      }
    },
    d
  ) : /* @__PURE__ */ e.createElement("span", { className: _, style: i }, d);
}
const Zo = "_wrapper_15dm4_1", er = "_disabled_15dm4_8", tr = "_track_15dm4_13", ar = "_checked_15dm4_30", nr = "_thumb_15dm4_34", sr = "_label_15dm4_50", re = {
  wrapper: Zo,
  disabled: er,
  track: tr,
  checked: ar,
  thumb: nr,
  label: sr
};
function Wc({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: s,
  disabled: r = !1,
  color: o
}) {
  const l = t ? n : s;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && o !== void 0 ? { background: o } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const or = "_card_1uh3t_1", rr = "_active_1uh3t_24", cr = "_iconChip_1uh3t_29", lr = "_body_1uh3t_41", ir = "_label_1uh3t_48", _r = "_description_1uh3t_54", ce = {
  card: or,
  active: rr,
  iconChip: cr,
  body: lr,
  label: ir,
  description: _r
};
function zc(t) {
  const { icon: a, label: n, description: s, active: r = !1, onClick: o } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: o,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), s && /* @__PURE__ */ e.createElement("span", { className: ce.description }, s))
  );
}
const dr = "_breadcrumb_zkol9_1", mr = "_list_zkol9_6", pr = "_item_zkol9_16", ur = "_link_zkol9_22", Er = "_plain_zkol9_43", br = "_current_zkol9_48", fr = "_separator_zkol9_54", ae = {
  breadcrumb: dr,
  list: mr,
  item: pr,
  link: ur,
  plain: Er,
  current: br,
  separator: fr
};
function Kc(t) {
  const { items: a, separator: n = "/", textColor: s, hoverColor: r, currentColor: o } = t, l = {
    ...s !== void 0 ? { "--ax-bc-text": s } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...o !== void 0 ? { "--ax-bc-current": o } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ae.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ae.list }, a.map((_, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: ae.item }, i ? /* @__PURE__ */ e.createElement("span", { className: ae.current, "aria-current": "page" }, _.label) : _.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.link,
        onClick: _.onClick
      },
      _.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ae.plain }, _.label), !i && /* @__PURE__ */ e.createElement("span", { className: ae.separator, "aria-hidden": "true" }, n));
  })));
}
const yr = "_treeItem_1ouqz_1", gr = "_active_1ouqz_18", hr = "_chevron_1ouqz_28", vr = "_chevronExpanded_1ouqz_48", kr = "_chevronSpacer_1ouqz_52", Nr = "_icon_1ouqz_57", Ar = "_label_1ouqz_69", $r = "_count_1ouqz_76", wr = "_dark_1ouqz_86", H = {
  treeItem: yr,
  active: gr,
  chevron: hr,
  chevronExpanded: vr,
  chevronSpacer: kr,
  icon: Nr,
  label: Ar,
  count: $r,
  dark: wr
};
function Hc(t) {
  const {
    icon: a,
    label: n,
    count: s,
    indent: r = 0,
    active: o = !1,
    expandable: l = !1,
    expanded: _ = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, d = (b) => {
    b.stopPropagation(), i == null || i();
  }, p = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${p} ${o ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": o,
      "aria-expanded": l ? _ : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${_ ? H.chevronExpanded : ""}`,
        onClick: d,
        "aria-label": _ ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof s == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, s)
  );
}
const xr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ie(t) {
  return Array.from(t.querySelectorAll(xr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let De = 0, Me = "";
function ze(t) {
  const a = J(null), n = J(t);
  n.current = t;
  const s = J(void 0);
  return s.current === void 0 && (s.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var _;
    const o = a.current, l = (_ = s.current) != null ? _ : null;
    return o && !o.contains(document.activeElement) && (Ie(o)[0] || o).focus(), De++ === 0 && (Me = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --De === 0 && (document.body.style.overflow = Me), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (o) => {
    const l = a.current;
    if (!l) return;
    if (o.key === "Escape") {
      o.stopPropagation(), n.current();
      return;
    }
    if (o.key !== "Tab" || !l.contains(o.target)) return;
    const _ = Ie(l);
    if (_.length === 0) {
      o.preventDefault(), l.focus();
      return;
    }
    const c = _[0], i = _[_.length - 1], m = document.activeElement;
    o.shiftKey && (m === c || m === l) ? (o.preventDefault(), i.focus()) : !o.shiftKey && m === i && (o.preventDefault(), c.focus());
  } };
}
const Xr = "_backdrop_gstyy_1", Cr = "_panel_gstyy_9", Sr = "_right_gstyy_21", Br = "_left_gstyy_27", Fr = "_header_gstyy_51", jr = "_icon_gstyy_59", Lr = "_titleGroup_gstyy_66", Ir = "_kicker_gstyy_71", Dr = "_title_gstyy_66", Mr = "_subtitle_gstyy_87", Pr = "_closeButton_gstyy_93", Rr = "_body_gstyy_115", Tr = "_footer_gstyy_123", j = {
  backdrop: Xr,
  panel: Cr,
  right: Sr,
  left: Br,
  header: Fr,
  icon: jr,
  titleGroup: Lr,
  kicker: Ir,
  title: Dr,
  subtitle: Mr,
  closeButton: Pr,
  body: Rr,
  footer: Tr
};
function Uc(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Or, { ...t }) : null;
}
function Or({
  onClose: t,
  icon: a,
  kicker: n,
  title: s,
  titleSize: r,
  titleWeight: o,
  subtitle: l,
  footer: _,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: d
}) {
  const { dialogRef: p, onKeyDown: b } = ze(t), y = Te("ax-drawer-t"), E = [j.panel, i === "left" ? j.left : j.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...o !== void 0 ? { fontWeight: o } : {}
  }, $ = d !== void 0 ? { top: d, height: `calc(100vh - ${d}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: j.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: p,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: $,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: j.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: j.icon }, a), /* @__PURE__ */ e.createElement("div", { className: j.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: j.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: j.title, id: y, style: h }, s), l && /* @__PURE__ */ e.createElement("p", { className: j.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: j.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: j.body }, c),
    _ && /* @__PURE__ */ e.createElement("div", { className: j.footer }, _)
  ));
}
const Gr = "_backdrop_6kso7_1", qr = "_menu_6kso7_8", Wr = "_alignRight_6kso7_24", zr = "_alignLeft_6kso7_28", Kr = "_item_6kso7_32", Hr = "_itemIcon_6kso7_50", Ur = "_itemText_6kso7_59", Vr = "_itemLabel_6kso7_66", Qr = "_itemDescription_6kso7_72", Yr = "_danger_6kso7_77", R = {
  backdrop: Gr,
  menu: qr,
  alignRight: Wr,
  alignLeft: zr,
  item: Kr,
  itemIcon: Hr,
  itemText: Ur,
  itemLabel: Vr,
  itemDescription: Qr,
  danger: Yr
};
function Vc(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Jr, { ...t }) : null;
}
function Jr({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const s = J(null), r = J(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var i, m, d;
    const c = (i = r.current) != null ? i : null;
    return (d = (m = s.current) == null ? void 0 : m.querySelector("button")) == null || d.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const o = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, _ = (c) => {
    var p, b;
    const i = Array.from((b = (p = s.current) == null ? void 0 : p.querySelectorAll("button")) != null ? b : []), m = i.indexOf(document.activeElement), d = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? d(m + 1) : c.key === "ArrowUp" ? d(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? d(0) : c.key === "End" ? d(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(Ke, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: s, role: "menu", className: o, onClick: (c) => c.stopPropagation(), onKeyDown: _ }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const Zr = "_backdrop_3pc9i_1", ec = "_card_3pc9i_12", tc = "_header_3pc9i_23", ac = "_icon_3pc9i_31", nc = "_titleGroup_3pc9i_38", sc = "_title_3pc9i_38", oc = "_subtitle_3pc9i_50", rc = "_closeButton_3pc9i_56", cc = "_body_3pc9i_78", lc = "_footer_3pc9i_85", T = {
  backdrop: Zr,
  card: ec,
  header: tc,
  icon: ac,
  titleGroup: nc,
  title: sc,
  subtitle: oc,
  closeButton: rc,
  body: cc,
  footer: lc
};
function Qc(t) {
  return t.open ? /* @__PURE__ */ e.createElement(ic, { ...t }) : null;
}
function ic({
  onClose: t,
  icon: a,
  title: n,
  subtitle: s,
  footer: r,
  width: o = 480,
  children: l
}) {
  const { dialogRef: _, onKeyDown: c } = ze(t), i = Te("ax-modal-t"), m = typeof o == "number" ? `${o}px` : o;
  return /* @__PURE__ */ e.createElement("div", { className: T.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: _,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: T.card,
      style: { width: m },
      onClick: (d) => d.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: T.header }, a && /* @__PURE__ */ e.createElement("span", { className: T.icon }, a), /* @__PURE__ */ e.createElement("div", { className: T.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: T.title, id: i }, n), s && /* @__PURE__ */ e.createElement("p", { className: T.subtitle }, s)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: T.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: T.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: T.footer }, r)
  ));
}
export {
  Zc as ACTIVE_AFFILIATION_KEY_PREFIX,
  el as ACTIVE_COM_HEADER,
  tl as ACTIVE_DEPT_HEADER,
  zc as AXActionCard,
  kc as AXAiIconBadge,
  Fc as AXAiSuggestionBanner,
  We as AXAvatar,
  Nc as AXAvatarStack,
  Ac as AXBadge,
  Kc as AXBreadcrumb,
  Tc as AXButton,
  gc as AXCardPanel,
  $c as AXCommentRow,
  fc as AXCommentThread,
  Pc as AXDataTable,
  hc as AXDivider,
  Uc as AXDrawer,
  Vc as AXDropdownMenu,
  Am as AXERP_EMPTY_SET_TEXT,
  al as AXE_MONEY_REJECT_TEXT,
  jc as AXEmptyState,
  nl as AXErpAccordion,
  sl as AXErpActionMenu,
  ol as AXErpAiAnswerPanel,
  rl as AXErpAiSearch,
  cl as AXErpBanner,
  ll as AXErpBarChart,
  il as AXErpButton,
  _l as AXErpCalculatorModal,
  dl as AXErpCalculatorProvider,
  ml as AXErpCalendar,
  pl as AXErpCard,
  ul as AXErpCheckGroup,
  El as AXErpCheckList,
  bl as AXErpCheckbox,
  fl as AXErpCodeBadge,
  yl as AXErpCodePicker,
  gl as AXErpContextHelp,
  hl as AXErpContextMenu,
  vl as AXErpCriticalAlert,
  kl as AXErpCsvButton,
  Nl as AXErpCsvPick,
  Al as AXErpDataTable,
  $l as AXErpDatePicker,
  wl as AXErpDateRange,
  xl as AXErpDonutChart,
  Xl as AXErpDropArea,
  Cl as AXErpDropdown,
  Sl as AXErpEmptySet,
  Bl as AXErpError,
  Fl as AXErpEtaxError,
  jl as AXErpEtaxXmlPanel,
  Ll as AXErpField,
  Il as AXErpFileButton,
  Dl as AXErpFileDrop,
  Ml as AXErpFilterBand,
  Pl as AXErpFormModal,
  Rl as AXErpFormRow,
  Tl as AXErpFormSection,
  Ol as AXErpGantt,
  Gl as AXErpGisuField,
  ql as AXErpGlyph,
  Wl as AXErpGrid,
  zl as AXErpGridStatus,
  Kl as AXErpHint,
  Hl as AXErpIcon,
  Ul as AXErpIconButton,
  Vl as AXErpImageThumbs,
  Ql as AXErpKanban,
  Yl as AXErpKpiTile,
  Jl as AXErpKpiTileGroup,
  Zl as AXErpLinkButton,
  ei as AXErpLoadMore,
  ti as AXErpMainScreen,
  ai as AXErpMenuAreaHead,
  ni as AXErpMenuGroup,
  si as AXErpMiniCalendar,
  oi as AXErpModal,
  ri as AXErpMoneyInput,
  ci as AXErpMsg,
  li as AXErpMultiSelect,
  ii as AXErpNote,
  _i as AXErpOverviewGrid,
  di as AXErpPage,
  mi as AXErpPageBody,
  pi as AXErpPageFrame,
  ui as AXErpPagination,
  Ei as AXErpPill,
  bi as AXErpPopover,
  fi as AXErpProgressBar,
  yi as AXErpProposalBanner,
  gi as AXErpProposalCards,
  hi as AXErpProposalList,
  vi as AXErpProposalModal,
  ki as AXErpQtyInput,
  Ni as AXErpQuickMenu,
  Ai as AXErpRadioGroup,
  $i as AXErpReadonly,
  wi as AXErpReadout,
  xi as AXErpSaveBar,
  Xi as AXErpSearchBar,
  Ci as AXErpSelect,
  Si as AXErpShortcutHelp,
  Bi as AXErpSideBar,
  Fi as AXErpSidePanel,
  ji as AXErpSidePanelGroup,
  Li as AXErpSkipLink,
  Ii as AXErpSortAnnounce,
  Di as AXErpSortButton,
  Mi as AXErpSortTh,
  Pi as AXErpSpinner,
  Ri as AXErpStartGuide,
  Ti as AXErpStatCard,
  Oi as AXErpStateBadge,
  Gi as AXErpStepIndicator,
  qi as AXErpSummaryCard,
  Wi as AXErpSummaryList,
  zi as AXErpSwitch,
  Ki as AXErpTabs,
  Hi as AXErpTag,
  Ui as AXErpTagList,
  Vi as AXErpTextInput,
  Qi as AXErpTitleBar,
  Yi as AXErpToastProvider,
  Ji as AXErpToggle,
  Zi as AXErpTooltip,
  e_ as AXErpTreeCell,
  t_ as AXErpVerify,
  a_ as AXErpVirtualBody,
  n_ as AXErpVisuallyHidden,
  s_ as AXErpWeekStepper,
  o_ as AXErpWeekStrip,
  Lc as AXExpandableSummary,
  wc as AXFileChip,
  Oa as AXFileTypeIcon,
  Oc as AXIconButton,
  Rc as AXKeyValueGrid,
  xc as AXKeyValueRow,
  Xc as AXListRow,
  Qc as AXModal,
  vc as AXPanelHeader,
  Cc as AXPersonRow,
  Ic as AXProgressBar,
  Sc as AXRankingRow,
  r_ as AXSearchInput,
  Gc as AXSegmentedControl,
  Bc as AXStatusBadge,
  Dc as AXStepProgress,
  qc as AXTagChip,
  Wc as AXToggleSwitch,
  Hc as AXTreeItem,
  Mc as AXTypingDots,
  c_ as AX_ERP_CALENDAR_KO,
  l_ as AX_ERP_DIRTY_MESSAGE,
  i_ as AX_ERP_MENU_GROUP_LABELS,
  __ as AX_ERP_PROPOSAL_TEXT,
  d_ as AX_ERP_QUICK_MENU_LABELS,
  m_ as AX_ERP_SHORTCUTS,
  Ec as CurrencyUnit,
  p_ as ERP_AREA_BASE,
  u_ as ERP_AREA_MIN,
  E_ as ERP_AREA_MIN_PINNED,
  b_ as ERP_HOST_SIDE,
  f_ as ERP_HOST_TOP,
  y_ as ERP_PAGE_MIN_WIDTH,
  g_ as ERP_PAGE_MIN_WIDTH_MAX,
  h_ as ERP_SQUASHED_BOX_H,
  v_ as ERP_VIEWPORT_BASE,
  k_ as ERP_VIEWPORT_MIN,
  Re as GW_ORIGIN,
  N_ as JAPANESE_ERAS,
  A_ as OBTPortal,
  $_ as OBTResizeContainer,
  w_ as OBTResizeSensor,
  x_ as REFRESH_KEY,
  X_ as SESSION_EXPIRED_EVENT,
  C_ as TOKEN_KEY,
  S_ as activeAffiliationHeaders,
  $m as amDigits,
  wm as amNumber,
  le as authorizedFetch,
  B_ as axErpAddDays,
  F_ as axErpAriaSort,
  j_ as axErpAutoLineAm,
  L_ as axErpCalendarLocale,
  I_ as axErpCapabilityName,
  D_ as axErpChangedKeys,
  M_ as axErpCodeDisplay,
  P_ as axErpCodeLabel,
  R_ as axErpCodeNameOf,
  T_ as axErpCompareSortValue,
  O_ as axErpDownload,
  xm as axErpEmptySetText,
  G_ as axErpEtaxGenerate,
  q_ as axErpEtaxGet,
  W_ as axErpEtaxHistory,
  z_ as axErpEtaxPreflight,
  K_ as axErpEtaxReason,
  H_ as axErpFileName,
  U_ as axErpGisuLabel,
  V_ as axErpHostLang,
  Q_ as axErpHttpMessage,
  Y_ as axErpIsHelpKey,
  J_ as axErpKeepInPlace,
  Z_ as axErpKpiColumns,
  ed as axErpMenuItem,
  td as axErpMenuSection,
  ad as axErpMergeBase,
  nd as axErpNextSort,
  sd as axErpPageCount,
  od as axErpPageItems,
  rd as axErpParsePage,
  cd as axErpQtyDecimals,
  ld as axErpQtyFormat,
  id as axErpQtyOutOfRange,
  _d as axErpQtyParse,
  dd as axErpQtyRound,
  md as axErpQtyStep,
  pd as axErpQtyTimesUnit,
  ud as axErpRangeValid,
  Ed as axErpRovingMove,
  bd as axErpRowActivate,
  fd as axErpSameValues,
  yd as axErpSaveBlob,
  gd as axErpSaveCsv,
  hd as axErpSortForest,
  vd as axErpSortMessage,
  kd as axErpSortValue,
  Nd as axErpSubmitShortcutLabel,
  Ad as axErpTableToCsv,
  $d as axErpTotalLabel,
  wd as axErpWeekOf,
  xd as clampErpPageMinWidth,
  Xd as clearTokens,
  pc as colors,
  Cd as configureAuth,
  bc as configureComments,
  Sd as csvFormulaGuard,
  Bd as csvNumber,
  Qe as currencyDigits,
  He as currencyText,
  Fd as currentUsername,
  jd as decodeClaims,
  uc as ensureBaseCurrency,
  Ld as eraOf,
  Id as eraShortDate,
  Dd as eraYearLabel,
  Md as erpPageScrollIssues,
  Xm as fmtAm,
  Pd as fmtDt,
  Cm as fmtDtMin,
  Ve as fmtMoney,
  Sm as fmtMoneyText,
  Bm as fmtNum,
  Fm as fmtNumBlank,
  jm as fmtNumDash,
  Lm as fmtYen,
  Pe as getActiveAffiliation,
  Im as getBaseCurrency,
  Rd as getFreshToken,
  Td as getStoredToken,
  Od as hasUnsavedHint,
  Gd as isExpired,
  qd as isNumericCellText,
  Wd as isRefreshExpired,
  et as isReply,
  zd as measureMoneyMetrics,
  Kd as moneyColWidth,
  Hd as moneyColWidthForDigits,
  Ue as moneyUnit,
  Ud as notifySessionExpired,
  Vd as onActiveAffiliationChange,
  Qd as onSessionExpired,
  Ye as pickCurrencyCode,
  Yd as refreshTokens,
  Jd as saveTokens,
  Dm as setAXErpEmptySetText,
  Zd as setActiveAffiliation,
  Oe as setBaseCurrency,
  em as setUnsavedHint,
  tm as startRefreshExpiryWatch,
  am as stopRefreshExpiryWatch,
  nm as textColWidth,
  sm as textWidth,
  Je as toCurrency,
  Mm as toHalfWidth,
  om as todayLocal,
  rm as useAXErpBusy,
  cm as useAXErpCalculator,
  lm as useAXErpConfirm,
  im as useAXErpDirtyGuard,
  _m as useAXErpEditor,
  dm as useAXErpFilePicker,
  mm as useAXErpKitLang,
  pm as useAXErpNotice,
  um as useAXErpPaged,
  Em as useAXErpQuery,
  bm as useAXErpQuickMenu,
  fm as useAXErpRovingGrid,
  ym as useAXErpRunLock,
  gm as useAXErpShortcutHelp,
  hm as useAXErpSubmitShortcut,
  vm as useAXErpToast,
  km as useAXErpTree,
  Te as useAXErpUid,
  yc as useCommentCounts,
  rt as useComments,
  Ze as useCurrency
};
